<template>
	<v-col class="purchase-product">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Belanja Produk</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-storefront</v-icon>
			<div class="pl-2">Stockist Area</div>
			<div class="px-2">/</div>
			<div>Belanja Produk</div>
		</div>

		<div class="mt-5">
			<Stockist></Stockist>
		</div>
	</v-col>
</template>

<script>
import { mapState } from 'vuex'
import Stockist from './components/Stockist';

export default {
	components: {
		Stockist
	},
	data() {
		return {
		}
	},
	computed: {
		...mapState('auth', ['userData']),
	},
	methods: {
	},
	created(){
		this.$store.dispatch('setPageTitle', `Belanja Produk`)
	},
};
</script>
